import { useTranslation } from "react-i18next";
import buildImg from "@/assets/build-section.jpg";

interface Quote {
  q: string;
  role: string;
  org: string;
}

export const Testimonials = () => {
  const { t } = useTranslation();
  const quotes = t("impact.quotes", { returnObjects: true }) as Quote[];

  return (
    <section id="impact" className="bg-cream text-cream-foreground py-24 md:py-32">
      <div className="container-x">
        <div className="grid md:grid-cols-2 gap-12 items-end mb-16">
          <div>
            <p className="text-[10px] uppercase tracking-[0.3em] text-cream-foreground/60 mb-6">
              {t("impact.eyebrow")}
            </p>
            <h2 className="font-display text-3xl md:text-5xl font-light tracking-tight leading-[1.1]">
              {t("impact.title")}
            </h2>
          </div>
          <p className="text-base text-cream-foreground/70 leading-relaxed max-w-md">
            {t("impact.intro")}
          </p>
        </div>

        <div className="aspect-[21/9] overflow-hidden rounded-sm mb-12">
          <img
            src={buildImg}
            alt=""
            loading="eager"
            decoding="async"
            width={1600}
            height={1200}
            className="h-full w-full object-cover"
          />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {quotes.map((q, i) => (
            <article
              key={i}
              className="glass-light rounded-2xl p-8 flex flex-col justify-between min-h-[260px] transition-all duration-500 hover:-translate-y-1"
            >
              <blockquote className="text-base text-cream-foreground leading-relaxed font-light">
                "{q.q}"
              </blockquote>
              <footer className="mt-8">
                <p className="text-sm text-cream-foreground">{q.org}</p>
                <p className="text-xs text-cream-foreground/60 mt-1">{q.role}</p>
              </footer>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
